import axios from 'axios'

const state = {
    puntajeDatosCliente: {
        registro: null,
        informacionBasica: null,
        fechaNacimiento: null,
        estadoCivil: null,
        contacto: null,
        direccion: null,
        categorias: null,
        medioTransporte: null
    },
    subcategorias: null
};

const mutations = {
    setPuntajeDatosCliente(state, puntaje) {
        state.puntajeDatosCliente.registro = puntaje[0]
        state.puntajeDatosCliente.informacionBasica = puntaje[1]
        state.puntajeDatosCliente.fechaNacimiento = puntaje[2]
        state.puntajeDatosCliente.estadoCivil = puntaje[3]
        state.puntajeDatosCliente.contacto = puntaje[4]
        state.puntajeDatosCliente.direccion = puntaje[5]
        state.puntajeDatosCliente.categorias = puntaje[6]
        state.puntajeDatosCliente.medioTransporte = puntaje[7]
    },
    setSubcategorias(state, subcategorias) {

        subcategorias.forEach(subcategoria => {
            subcategoria.svg = "data:image/svg+xml;utf8," + subcategoria.svg.replace("#", "%23")
        });

        state.subcategorias = subcategorias
    }
};

const actions = {
    consultarConfiguracion({ commit, dispatch }) {
        commit('mostrarOcupado', 'Conectando...')

     /*var xhr = new XMLHttpRequest();
      var url = "https://clientes.lacentral.com.co/api/Configuracion/ConsultarPuntajeDatosCliente";
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var json = JSON.parse(xhr.responseText);      
          commit('setPuntajeDatosCliente', json);                
          commit('ocultarOcupado');
          return true
        }        
      };
      xhr.send();*/
      

      

        axios.post('api/Configuracion/ConsultarPuntajeDatosCliente')
            .then(res => {
                commit('setPuntajeDatosCliente', res.data);                
                commit('ocultarOcupado');
                return true
            })
            .catch(() => {
                dispatch('mostrarMensaje', {
                    imagen: 'emo-sad',
                    titulo: 'Error Consultando la Información',
                    contenido: 'Se presentaron problemas consultando la información.'
                })
                commit('ocultarOcupado')
                return false
            })
    }
};

const getters = {
    puntajeDatosCliente(state) {
        return state.puntajeDatosCliente
    },
    totalpuntajeDatosCliente(state) {
        let total = 0

        for (var key in state.puntajeDatosCliente) {
            if (state.puntajeDatosCliente[key]) {
                total += parseInt(state.puntajeDatosCliente[key].valor)
            }
        }

        return total
    },
    subcategorias(state) {
        return state.subcategorias
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};